export const SET_SELECTED_REQUEST = 'SET_SELECTED_REQUEST';
export const RESET_SELECTED_REQUEST = 'RESET_SELECTED_REQUEST';

export const setSelectedRequest = (request) => ({
  type: SET_SELECTED_REQUEST,
  payload: request,
});

export const resetSelectedRequest = () => ({
  type: RESET_SELECTED_REQUEST,
});
